import React, { useEffect, useState } from "react";
import { BTN_GHOST } from "../../../../styles";
import { HtmlContentFrame } from "../../../../components/HtmlContentFrame";
import { sourceImage } from "../../../../utils/source-image";
import {
  getVestibularConfig,
  uploadVestibularHtml,
  uploadVestibularAttachment,
} from "../../../../services/vestibularesApi";
export default function AdminVestibulares() {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [enviando, setEnviando] = useState(false);
  const [erro, setErro] = useState("");
  const [statusProcessamento, setStatusProcessamento] = useState("");
  useEffect(() => {
    let ativo = true;
    getVestibularConfig()
      .then((data) => {
        if (ativo) setConfig(data);
      })
      .finally(() => {
        if (ativo) setLoading(false);
      });
    return () => {
      ativo = false;
    };
  }, []);
  const handleUpload = async (event) => {
    const file = event.target.files?.[0];
    event.target.value = "";
    if (!file) return;
    setEnviando(true);
    setErro("");
    setStatusProcessamento("Lendo arquivo HTML...");
    try {
      // 1. Ler os primeiros 20MB para verificar se contém __RQ_EMBEDDED_ASSETS
      const headerBlob = file.slice(0, 20 * 1024 * 1024);
      const headerText = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (eventAtual2) => resolve(eventAtual2.target.result);
        reader.onerror = (err) => reject(err);
        reader.readAsText(headerBlob);
      });
      const isRqVirtualAssets =
        headerText.indexOf("window.__RQ_EMBEDDED_ASSETS") !== -1 ||
        headerText.indexOf("__RQ_EMBEDDED_ASSETS") !== -1;
      let optimizedFile;
      if (isRqVirtualAssets) {
        setStatusProcessamento(
          "Identificado formato virtual do Banco de Questões. Analisando índice...",
        );

        // Achar início do JSON
        const match = /__RQ_EMBEDDED_ASSETS\s*=\s*\{/i.exec(headerText);
        if (!match) {
          throw new Error(
            "Atribuição __RQ_EMBEDDED_ASSETS não encontrada no cabeçalho do arquivo.",
          );
        }
        const startIdx = match.index;
        const startBrace = headerText.indexOf("{", startIdx);
        const endBrace = headerText.indexOf("};", startBrace);
        if (startBrace === -1 || endBrace === -1) {
          throw new Error(
            "Índice de assets __RQ_EMBEDDED_ASSETS corrompido ou não encontrado no arquivo.",
          );
        }
        const jsonText = headerText.substring(startBrace, endBrace + 1);
        const assetsIndex = JSON.parse(jsonText);
        const assetKeys = Object.keys(assetsIndex);
        setStatusProcessamento(
          `Localizando arquivos de mídia no arquivo (${assetKeys.length} arquivos encontrados)...`,
        );

        // Achar as posições absolutas de todas as tags de template no arquivo
        const templatePositions = {};
        const chunkSize = 12 * 1024 * 1024; // 12MB
        let scanOffset = 14 * 1024 * 1024; // Iniciar depois de 14MB

        while (scanOffset < file.size) {
          const blob = file.slice(scanOffset, scanOffset + chunkSize + 200);
          const text = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (eventAtual2) => resolve(eventAtual2.target.result);
            reader.onerror = (err) => reject(err);
            reader.readAsText(blob);
          });
          const regex = /<template id="rq-embedded-assets(?:-(\d+))?">/g;
          let match;
          while ((match = regex.exec(text)) !== null) {
            const templateIdx = match[1] ? parseInt(match[1], 10) : 0;
            const tagStartInChunk = match.index;
            const tagLength = match[0].length;
            const absoluteContentStart =
              scanOffset + tagStartInChunk + tagLength;
            templatePositions[templateIdx] = absoluteContentStart;
          }
          scanOffset += chunkSize;
        }

        // Também verificar se o template está no primeiro bloco (caso muito pequeno)
        const firstTemplateRegex =
          /<template id="rq-embedded-assets(?:-(\d+))?">/g;
        let matchFirst;
        while ((matchFirst = firstTemplateRegex.exec(headerText)) !== null) {
          const templateIdx = matchFirst[1] ? parseInt(matchFirst[1], 10) : 0;
          const tagStartInChunk = matchFirst.index;
          const tagLength = matchFirst[0].length;
          templatePositions[templateIdx] = tagStartInChunk + tagLength;
        }
        setStatusProcessamento(
          `Processando e enviando ${assetKeys.length} arquivos de mídia em lotes...`,
        );
        const rqAssetUrls = {};

        // Enviar os arquivos em lotes paralelos de 10
        const batchSize = 10;
        for (let index = 0; index < assetKeys.length; index += batchSize) {
          const batchKeys = assetKeys.slice(index, index + batchSize);
          setStatusProcessamento(
            `Enviando mídias: ${index + 1} a ${Math.min(index + batchSize, assetKeys.length)} de ${assetKeys.length}...`,
          );
          const uploadPromises = batchKeys.map(async (name) => {
            const row = assetsIndex[name];
            if (!row) return;
            let templateIdx = 0;
            let offset = 0;
            let length = 0;
            let mime = "application/octet-stream";
            if (row.length === 3) {
              offset = row[0];
              length = row[1];
              mime = row[2];
            } else if (row.length >= 4) {
              templateIdx = row[0];
              offset = row[1];
              length = row[2];
              mime = row[3];
            }
            const templateContentStart = templatePositions[templateIdx];
            if (templateContentStart === undefined) {
              console.warn(
                `Template rq-embedded-assets-${templateIdx} não encontrado no arquivo.`,
              );
              return;
            }
            const absoluteStart = templateContentStart + offset;
            const assetBlob = file.slice(absoluteStart, absoluteStart + length);
            const base64Data = await new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.onload = (eventAtual2) =>
                resolve(eventAtual2.target.result);
              reader.onerror = (err) => reject(err);
              reader.readAsText(assetBlob);
            });

            // Converter base64 em Blob de mídia
            const cleanData = base64Data.replace(/\s/g, "");
            const binaryString = atob(cleanData);
            const len = binaryString.length;
            const bytes = new Uint8Array(len);
            for (let indexAtual2 = 0; indexAtual2 < len; indexAtual2++) {
              bytes[indexAtual2] = binaryString.charCodeAt(indexAtual2);
            }
            const mediaBlob = new Blob([bytes], {
              type: mime,
            });

            // Identificar extensão
            let ext = "bin";
            const mimeParts = mime.split("/");
            if (mimeParts.length === 2) {
              ext = mimeParts[1].split("+")[0];
            }
            const mimeToExt = {
              jpeg: "jpg",
              "svg+xml": "svg",
              plain: "txt",
            };
            if (mimeToExt[ext]) {
              ext = mimeToExt[ext];
            }
            const fileName = `ext_file_${Date.now()}_${Math.random().toString(36).substr(2, 5)}.${ext}`;
            const extractedFile = new File([mediaBlob], fileName, {
              type: mime,
            });
            const url = await uploadVestibularAttachment(extractedFile);
            if (url) {
              rqAssetUrls[name] = url;
            }
          });
          await Promise.all(uploadPromises);
        }
        setStatusProcessamento(
          "Reconstruindo e limpando arquivo HTML final...",
        );

        // Achar onde o primeiro template de ASSETS (mídias) começa para cortar o arquivo lá,
        // preservando os templates de PACKS (questões/textos) que vêm antes.
        let cutIndex = headerText.indexOf('<template id="rq-embedded-assets');
        if (cutIndex === -1) {
          cutIndex = headerText.indexOf("<template id=");
        }
        if (cutIndex === -1) {
          cutIndex = headerText.length;
        }
        let cleanHeader = headerText.substring(0, cutIndex);

        // Injetar o mapeamento no rqAssetUrls existente
        const targetSearch = "var rqAssetUrls=Object.create(null);";
        if (cleanHeader.indexOf(targetSearch) !== -1) {
          cleanHeader = cleanHeader.replace(
            targetSearch,
            `var rqAssetUrls = ${JSON.stringify(rqAssetUrls)};`,
          );
        } else {
          // Se não achar no formato exato, injeta como script no final do head
          cleanHeader = cleanHeader.replace(
            "</head>",
            `<script>var rqAssetUrls = ${JSON.stringify(rqAssetUrls)};</script>\n</head>`,
          );
        }

        // Fechar HTML sem os templates gigantes
        const finalBlob = new Blob([cleanHeader, "\n</body>\n</html>"], {
          type: "text/html",
        });
        optimizedFile = new File([finalBlob], file.name, {
          type: "text/html",
        });
      } else {
        // Fallback: Arquivo tradicional de tamanho menor
        setStatusProcessamento("Processando arquivo HTML tradicional...");
        const htmlText = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = (eventAtual2) => resolve(eventAtual2.target.result);
          reader.onerror = (err) => reject(err);
          reader.readAsText(file);
        });

        // Encontrar todos os base64 no HTML tradicional
        const regex = /data:([^;]+);base64,([^"')]+)/g;
        const matches = [];
        let match;
        while ((match = regex.exec(htmlText)) !== null) {
          const mime = match[1];
          const rawData = match[2];
          const fullMatch = match[0];
          const cleanData = rawData.replace(/\s/g, "");
          if (!matches.some((item) => item.cleanData === cleanData)) {
            matches.push({
              mime,
              cleanData,
              fullMatch,
            });
          }
        }
        let finalHtmlText = htmlText;
        if (matches.length > 0) {
          setStatusProcessamento(
            `Processando HTML tradicional: encontrados ${matches.length} arquivos.`,
          );
          for (let index = 0; index < matches.length; index++) {
            const { mime, cleanData, fullMatch } = matches[index];
            setStatusProcessamento(
              `Enviando arquivo tradicional ${index + 1} de ${matches.length}...`,
            );
            try {
              const binaryString = atob(cleanData);
              const len = binaryString.length;
              const bytes = new Uint8Array(len);
              for (let indexAtual2 = 0; indexAtual2 < len; indexAtual2++) {
                bytes[indexAtual2] = binaryString.charCodeAt(indexAtual2);
              }
              const blob = new Blob([bytes], {
                type: mime,
              });
              let ext = "bin";
              const mimeParts = mime.split("/");
              if (mimeParts.length === 2) {
                ext = mimeParts[1].split("+")[0];
              }
              const mimeToExt = {
                jpeg: "jpg",
                "svg+xml": "svg",
                plain: "txt",
              };
              if (mimeToExt[ext]) {
                ext = mimeToExt[ext];
              }
              const fileName = `ext_file_${Date.now()}_${Math.random().toString(36).substr(2, 5)}.${ext}`;
              const extractedFile = new File([blob], fileName, {
                type: mime,
              });
              const url = await uploadVestibularAttachment(extractedFile);
              if (url) {
                finalHtmlText = finalHtmlText.replaceAll(fullMatch, url);
              }
            } catch (decodeError) {
              console.error("Erro ao processar anexo base64:", decodeError);
            }
          }
        }
        const optimizedBlob = new Blob([finalHtmlText], {
          type: "text/html",
        });
        optimizedFile = new File([optimizedBlob], file.name, {
          type: "text/html",
        });
      }
      setStatusProcessamento("Enviando HTML final otimizado...");
      const resultado = await uploadVestibularHtml(optimizedFile);
      setConfig(resultado);
      setStatusProcessamento("");
    } catch (error) {
      console.error(error);
      setErro(
        error?.message ||
          error?.response?.data?.message ||
          "Não foi possível processar o arquivo. Certifique-se de que é um HTML válido.",
      );
      setStatusProcessamento("");
    } finally {
      setEnviando(false);
    }
  };
  const previewHtml = config?.html_url
    ? `<iframe src="${sourceImage(config.html_url)}" style="width:100%;min-height:600px;border:none;" scrolling="yes"></iframe>`
    : "";
  return (
    <div
      style={{
        display: "grid",
        gap: 16,
      }}
    >
      <div
        style={{
          border: "1px solid #E7EEF2",
          borderRadius: 12,
          padding: 16,
          background: "#FFF",
        }}
      >
        <div
          style={{
            fontSize: 13,
            fontWeight: 800,
            color: "#18212B",
            marginBottom: 4,
          }}
        >
          Arquivo HTML de Vestibulares
        </div>
        <div
          style={{
            fontSize: 12,
            color: "#64748B",
            marginBottom: 12,
          }}
        >
          Envie um unico arquivo .html — cada envio substitui o arquivo anterior
          e passa a ser exibido para os alunos na aba "Vestibulares".
        </div>

        <label
          style={{
            ...BTN_GHOST,
            display: "inline-flex",
            alignItems: "center",
            cursor: enviando ? "wait" : "pointer",
            opacity: enviando ? 0.6 : 1,
          }}
        >
          {enviando ? "Enviando..." : "Enviar arquivo HTML"}
          <input
            type="file"
            accept=".html,.htm,text/html"
            style={{
              display: "none",
            }}
            disabled={enviando}
            onChange={handleUpload}
          />
        </label>

        {statusProcessamento && (
          <div
            style={{
              marginTop: 10,
              color: "#2563EB",
              fontSize: 12,
              fontWeight: 700,
            }}
          >
            {statusProcessamento}
          </div>
        )}

        {erro && (
          <div
            style={{
              marginTop: 10,
              color: "#DC2626",
              fontSize: 12,
              fontWeight: 700,
            }}
          >
            {erro}
          </div>
        )}

        {!loading && config?.nome_arquivo && (
          <div
            style={{
              marginTop: 12,
              fontSize: 12,
              color: "#64748B",
            }}
          >
            Arquivo atual: <strong>{config.nome_arquivo}</strong>
            {config.updated_at && ` — atualizado em ${config.updated_at}`}
          </div>
        )}

        {!loading && !config?.html_url && (
          <div
            style={{
              marginTop: 12,
              fontSize: 12,
              color: "#94A3B8",
            }}
          >
            Nenhum arquivo enviado ainda.
          </div>
        )}
      </div>

      {previewHtml && (
        <div
          style={{
            border: "1px solid #E7EEF2",
            borderRadius: 12,
            padding: 12,
            background: "#F8FAFC",
          }}
        >
          <div
            style={{
              fontSize: 10,
              fontWeight: 900,
              color: "#64748B",
              marginBottom: 8,
            }}
          >
            Preview
          </div>
          <HtmlContentFrame
            html={previewHtml}
            title="Preview de Vestibulares"
            instanceKey="admin-preview:vestibulares"
          />
        </div>
      )}
    </div>
  );
}
export { AdminVestibulares };
